module.exports = __webpack_public_path__ + "img/add-new-venue.b81048f1.svg";